// Code review - In Progress
// Documentation - In Progress
import { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Checkbox from "../ReusableComponents/Checkbox";
import RadioGroup from "../ReusableComponents/RadioButton";

const Service = ({ data, data1, data2 }) => {
  const [testResultTypeDD, setTestResultTypeDD] = useState([]);
  const [serviceProvisionDD, setServiceProvisionDD] = useState([]);

  // Generic function to bind dropdown data
const bindDropdownData = (dataArray, setState) => {
  try {
    if (Array.isArray(dataArray)) {
      const formatted = dataArray.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setState(formatted);
    } else {
      console.error("Provided data is not an array");
      setState([]);
    }
  } catch (error) {
    console.error("Error binding dropdown data:", error);
    setState([]);
  }
};

// Use in useEffect
useEffect(() => {
  if (!data2 || !Array.isArray(data2)) return;

  bindDropdownData(data2[0], setTestResultTypeDD);
  bindDropdownData(data2[1], setServiceProvisionDD);
}, [data2]);


  const [itemsprovidedDD, setItemsprovidedDD] = useState([
    { value: 1, label: "Yes" },
    { value: 2, label: "No" },
  ]);
  const [renewalSupplyDD, setRenewalSupplyDD] = useState([
    { value: 1, label: "Yes" },
    { value: 2, label: "No" },
  ]);
  return (
    <div class="w-full ">
      <div className={mainTable.addShadowScreen}>
        <div className={mainTable.mainContentScreen}>
          <form class="overflow-auto p-5 md:h-96 min-h-fit max-h-fit ">
            <div className={mainTable.grid3}>
              <AutoDropDown
                classStar="text-red-500"
                title="Category"
                options={[]}
                placeholder="Select"
                name="category"
                selectedOption={data1[1]}
                Class="custom-class"
                tabIndex="1"
                disabled={true}
              />
              <AutoDropDown
                classStar="text-red-500"
                title="Sub-Category"
                options={[]}
                placeholder="Select"
                name="subCategory"
                selectedOption={data1[2]}
                Class="custom-class"
                tabIndex="1"
                disabled={true}
              />
              <InputText
                classStar="text-red-500"
                inputType={"text"}
                title={"Services"}
                name={"Services"}
                content={data.Services_en}
                disabled={true}
              />
              <RadioGroup
                classStar="text-red-500"
                title="Items Provided"
                type="radio"
                setName="itemsProvided"
                selectedOptions={data.ItemsProvided}
                options={itemsprovidedDD}
                disabled={true}
              />
              <div className="col-span-2">
                <RadioGroup
                  classStar="text-red-500"
                  title="Test Result Type ?"
                  type={"radio"}
                  setName={"testresulttype"}
                  selectedOptions={data1[0]}
                  options={testResultTypeDD}
                  disabled={true}
                />
              </div>
              <div className="col-span-3">
                <Checkbox
                  title="Service Provision"
                  type="Checkbox"
                  setName="serviceProvision"
                  options={serviceProvisionDD}
                  selectedOptions={data1[3]}
                  disabled={true}
                  tabIndex="0"
                  Class="grid grid-cols-2 md:grid md:grid-cols-4 lg:grid lg:grid-cols-5 items-center bg-gray-50 pl-4 border border-gray-300 rounded-lg "
                />
              </div>
              <InputText
                inputType={"text"}
                title={"Result UOM"}
                name={"resultUOM"}
                content={data.ResultUOM}
                disabled={true}
              />
              <RadioGroup
                classStar="text-red-500"
                title="Renewal Supply"
                type={"radio"}
                setName={"renewalSupply"}
                selectedOptions={data.RenewalSupply}
                options={renewalSupplyDD}
                disabled={true}
              />
              <InputText
                classStar="text-red-500"
                inputType={"text"}
                title={"Charges"}
                name={"charges"}
                content={data.Charges}
                disabled={true}
              />
              <InputText
                inputType={"text"}
                title={"PAC"}
                name={"pac"}
                content={data.PAC}
                disabled={true}
              />
              <InputText
                inputType={"text"}
                title={"FP Dropout"}
                name={"FPDropout"}
                content={data.FPDropout}
                disabled={true}
              />
              <InputText
                inputType={"text"}
                title={"CYP"}
                name={"cyp"}
                content={data.CYP}
                disabled={true}
              />
              <InputText
                inputType={"text"}
                title={"CYP Conversion Factor"}
                name={"CYPConversionFactor"}
                content={data.CYPConversionFactor}
                disabled={true}
              />
              <InputText
                inputType={"text"}
                title={"FP Item Provided"}
                name={"FPItemProvided"}
                content={data.FPItemProvided_en}
                disabled={true}
              />

              <InputText
                inputType={"text"}
                title={"Abortion Clients"}
                name={"abortionClients"}
                content={data.AbortionClients_en}
                disabled={true}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Service;
